import * as moment from 'moment';
import { Injectable } from '@angular/core';
import { AnalyticsDataModel } from '../models/analytics.datamodel';

@Injectable()
export class AnalyticsDataChachingService {
	public ANALYTICS_WIDGETS_CACHED_DATA = {
		data : {}
	}

	constructor(private analyticsDataModel: AnalyticsDataModel) {}

	getWidgetDataStatus(uniqueOverwriteID): any {
		let makeApi: boolean = !uniqueOverwriteID ? true : this.checkSelectionsChanges(uniqueOverwriteID);
		let widgetData = Object.assign({}, uniqueOverwriteID ? this.getDataFromConfig(uniqueOverwriteID) : {});
		return { makeApi, widgetData };
	}

	checkSelectionsChanges(uniqueOverwriteID): boolean {
		if (this.ANALYTICS_WIDGETS_CACHED_DATA.data[uniqueOverwriteID]?.['selections']?.['startDate']) {
			if (
				this.ANALYTICS_WIDGETS_CACHED_DATA.data[uniqueOverwriteID]['selections']['startDate'] !==
				moment(this.analyticsDataModel.startDate).format('DD-MM-YYYY')
			) {
				this.setSelections(uniqueOverwriteID);
				return true;
			} else if (
				this.ANALYTICS_WIDGETS_CACHED_DATA.data[uniqueOverwriteID]['selections']['endDate'] !==
				moment(this.analyticsDataModel.endDate).format('DD-MM-YYYY')
			) {
				this.setSelections(uniqueOverwriteID);
				return true;
			} else {
				if (
					this.ANALYTICS_WIDGETS_CACHED_DATA.data[uniqueOverwriteID]['selections']['advertiserIds'].length !==
					this.analyticsDataModel.selectedAdvertisers.length
				) {
					this.setSelections(uniqueOverwriteID);
					return true;
				} else {
					this.ANALYTICS_WIDGETS_CACHED_DATA.data[uniqueOverwriteID]['selections']['advertiserIds'].forEach((id) => {
						if (!this.analyticsDataModel.selectedAdvertisers.find((item) => item.id == id)) {
							this.setSelections(uniqueOverwriteID);
							return true;
						}
					});
				}

				if (
					this.ANALYTICS_WIDGETS_CACHED_DATA.data[uniqueOverwriteID]['selections']['campaignIds'].length !==
					this.analyticsDataModel.selectedCampaigns.length
				) {
					this.setSelections(uniqueOverwriteID);
					return true;
				} else {
					this.ANALYTICS_WIDGETS_CACHED_DATA.data[uniqueOverwriteID]['selections']['campaignIds'].forEach((id) => {
						if (!this.analyticsDataModel.selectedCampaigns.find((item) => item.id == id)) {
							this.setSelections(uniqueOverwriteID);
							return true;
						}
					});
				}
				return false;
			}
		} else {
			this.setSelections(uniqueOverwriteID);
			return true;
		}
	}

	setSelections(uniqueOverwriteID) {
		this.ANALYTICS_WIDGETS_CACHED_DATA.data[uniqueOverwriteID] = {
			selections: {}
		};
		this.ANALYTICS_WIDGETS_CACHED_DATA.data[uniqueOverwriteID]['selections']['startDate'] = moment(
			this.analyticsDataModel.startDate
		).format('DD-MM-YYYY');
		this.ANALYTICS_WIDGETS_CACHED_DATA.data[uniqueOverwriteID]['selections']['endDate'] = moment(
			this.analyticsDataModel.endDate
		).format('DD-MM-YYYY');
		this.ANALYTICS_WIDGETS_CACHED_DATA.data[uniqueOverwriteID]['selections']['advertiserIds'] =
			this.analyticsDataModel.selectedAdvertisers.map((adv) => adv.id);
		this.ANALYTICS_WIDGETS_CACHED_DATA.data[uniqueOverwriteID]['selections']['campaignIds'] =
			this.analyticsDataModel.selectedCampaigns.map((adv) => adv.id);
	}

	getDataFromConfig(uniqueOverwriteID): any {
		return this.ANALYTICS_WIDGETS_CACHED_DATA.data[uniqueOverwriteID]?.['response']
			? this.ANALYTICS_WIDGETS_CACHED_DATA.data[uniqueOverwriteID]['response']
			: {};
	}

	setDataInConfig(uniqueOverwriteID, response) {
		this.ANALYTICS_WIDGETS_CACHED_DATA.data[uniqueOverwriteID]['response'] = response;
	}

	removeDataFromConfig() {
		this.ANALYTICS_WIDGETS_CACHED_DATA.data = {};
	}

}
